import { IIconStyles, IStackStyles, ITheme, memoizeFunction } from '@fluentui/react';
import { pcpRedPalette } from './themes/palette';

const notificationIconPaddingREM = '0.225rem';
const notificationIconSizeREM = '1.25rem';

export const notificationIconContainerStyles = memoizeFunction(
    (theme: ITheme, horizontalAlign: 'left' | 'right'): IIconStyles => ({
        root: Object.assign(
            {
                borderRadius: notificationIconSizeREM, // Create a css circle. This should match the height.
                height: notificationIconSizeREM,
                minWidth: notificationIconSizeREM, // use min-width over width as we want to extend the width of the notification icon when contents is more than one character (e.g. 9+)
                background: pcpRedPalette.notificationForeground,
                padding: notificationIconPaddingREM,

                // positioning to place the badge within the button appropriately. Button DOM-element should have css 'position' other than 'static'.
                position: 'absolute',
                top: 0,
            }, 
            horizontalAlign == 'right' ?
                { right: 0 } :
                { left: 0 }
        ) as IIconStyles
    })
);

export const notificationTextStyles = memoizeFunction(
    (theme: ITheme): IStackStyles => ({
        root: {
            color: 'white',
            fontSize: theme.fonts.xSmall.fontSize   //10px
        }
    })
);